import React, { useEffect, useState } from "react";
import { api, V1 } from "@/lib/api";
import { Link } from "react-router-dom";

export default function ParentApplications() {
  const [apps, setApps] = useState([]);
  useEffect(() => {
    api.get(`${V1}/scholarship-applications/mine`).then((r) => setApps(r.data || []));
  }, []);

  return (
    <div className="space-y-6" data-testid="parent-applications-page">
      <div>
        <div className="overline text-accent">Başvurularım</div>
        <h1 className="font-display text-3xl font-bold tracking-tight">Bursluluk Başvurularım</h1>
      </div>
      <div className="rounded-xl border border-border bg-card overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-muted/50 text-xs uppercase tracking-widest text-muted-foreground">
            <tr>
              <th className="text-left p-3">Başvuru</th>
              <th className="text-left p-3">Öğrenci</th>
              <th className="text-left p-3">Okul</th>
              <th className="text-left p-3">Sınav Tarihi</th>
              <th className="text-left p-3">Durum</th>
            </tr>
          </thead>
          <tbody>
            {apps.length === 0 && <tr><td colSpan={5} className="p-10 text-center text-muted-foreground">Henüz başvuru yok. <Link to="/bursluluk-sinavlari" className="text-primary underline">Bursluluk sınavlarını keşfet</Link></td></tr>}
            {apps.map((a) => (
              <tr key={a.id} className="border-t border-border" data-testid={`app-row-${a.id}`}>
                <td className="p-3 font-mono text-xs">{a.application_no}</td>
                <td className="p-3">{a.child?.name} {a.child?.surname}</td>
                <td className="p-3">
                  <div className="font-medium">{a.school?.name}</div>
                  <div className="text-xs text-muted-foreground">{a.exam?.title}</div>
                </td>
                <td className="p-3">{a.exam?.exam_date ? new Date(a.exam.exam_date).toLocaleDateString("tr-TR") : "-"}</td>
                <td className="p-3"><span className="px-2 py-1 bg-muted rounded text-xs uppercase tracking-widest">{a.status}</span></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
